import { render } from "./TotalSalesForYearReportGrapics.vue?vue&type=template&id=1c66b946&scoped=true"
import script from "./TotalSalesForYearReportGrapics.vue?vue&type=script&lang=js"
export * from "./TotalSalesForYearReportGrapics.vue?vue&type=script&lang=js"

import "./TotalSalesForYearReportGrapics.vue?vue&type=style&index=0&id=1c66b946&scoped=true&lang=css"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c66b946"]])

export default __exports__